import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';

import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';

import EditAddressModal from 'components/RichProfile/MyAccount/AutoReplenishment/ManageAddress/EditAddressModal/EditAddressModal';

import AddressActions from 'actions/AddressActions';

import EditAddressModalEN from 'components/RichProfile/MyAccount/AutoReplenishment/ManageAddress/EditAddressModal/locales/EditAddressesModal_en_US';
import EditAddressModalFR from 'components/RichProfile/MyAccount/AutoReplenishment/ManageAddress/EditAddressModal/locales/EditAddressesModal_fr_CA';

const { wrapHOC } = FrameworkUtils;

const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(EditAddressModalEN, EditAddressModalFR);

const localization = createStructuredSelector({
    modalTitle: getTextFromResource(getText, 'modalTitle'),
    setAsDefault: getTextFromResource(getText, 'setAsDefault'),
    cancel: getTextFromResource(getText, 'cancel'),
    confirm: getTextFromResource(getText, 'confirm')
});

const fields = createSelector(localization, locales => ({ localization: locales }));

const functions = {
    validateAddress: AddressActions.validateAddress
};

const withEditAddressModalProps = wrapHOC(connect(fields, functions));

export default withEditAddressModalProps(EditAddressModal);
